$(function() {
    console.log('ready');

    $('#carouselMainpage').on('slide.bs.carousel', function (event) {
        //console.log(event.target);
        var num = $(event.target).find('.carousel-item').length;
        $(event.target).find('.carousel-numeric-indicator-digits').html(num+'/'+(event.to + 1));
    })

    $('#carouselMainpage').on('click', 'a', function() { // Task-14967-14 #10 5. Slideren amikor belelapozunk, akkor ne legyen benne automatikus fade, hanem onnantól csak manualitás és oldal újratöltéskor van csak automatikus fade
        $('#carouselMainpage').carousel('pause');
    });
/*
    // nagy szűrő logó meletti
    $("#searchField").catcomplete({
        delay: 0,
        minLength: 2,
        select: function (event, ui) {
            location.href = ui.item.fullUrl;
        },
        source: function (request, response) {
            $.ajax({
                url: "/ajaxRequest/search/findByTerm",
                dataType: "json",
                data: {
                    term: request.term,
                },
                success: function( data ) {
                    console.log(data);
                    //response(data.data);
                }
            });
        }
    });
*/

    var artistAutoComplete = $('.artistAutoComplete').selectize({
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        create: false,
        load: function(query, callback) {
            if (!query.length) return callback();
            $.ajax({
                url: '/ajaxRequest/artist/findByTerm?term=' + encodeURIComponent(query),
                type: 'GET',
                dataType: 'json',
                error: function() {
                    callback();
                },
                success: function(resp) {
                    console.log(resp);
                    callback(resp.data);
                }
            });
        },
        render: {
            item: function(item, escape) {
                console.log(item);
                return '<div>' +
                    (item.name.length > 25 ? item.name.substring(0,25)+'...' : escape(item.name)) +'</div>';
            }
        }
    });
    if(artistAutoComplete.length) {
        var artistAutoCompleteControl = artistAutoComplete[0].selectize;
        $('.artistAutoComplete').on('clearSelect', function () {
            artistAutoCompleteControl.clear(true);
        });
    }
    $('.selectize').selectize();

    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    newBuildArtists.init();
    newsletterBox.init();
});
